import React from 'react';
import PropTypes from 'prop-types';
import { Col, Dropdown, DropdownButton, Form, Row } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { faEye } from '@fortawesome/pro-solid-svg-icons';
import DownloadButton from '../download_button';
import { v4 as uuid } from 'uuid';
import { faCaretDown } from '@fortawesome/pro-regular-svg-icons';

export default function PhotoBulkActions({
  allSelected,
  bulkDownloadLink,
  disabled,
  label = 'Property Photos',
  showLimit,
  onBulkAttributeChange,
  onBulkDelete,
  onBulkDownload,
  onBulkPreview,
  onSelectAll
}) {
  const dropdownId = React.useRef(uuid());

  return (
    <Row className="align-items-center">
      <Col>
        <h6>
          {label}
          {showLimit && (<small className="text-muted ms-2 limit-label">(Limit: 100)</small>)}
        </h6>
      </Col>
      <Col xs="auto">
        <Form.Check
          checked={allSelected}
          className="text-accent"
          id={`${dropdownId.current}_toggle_all`}
          label={allSelected ? 'Unselect all photos' : 'Select all photos'}
          type="checkbox"
          onChange={onSelectAll}
        />
      </Col>
      <Col xs="auto">
        <DropdownButton
          id={dropdownId.current}
          title={<>Actions<FontAwesomeIcon icon={faCaretDown} /></>}
          variant="outline"
        >
          {typeof onBulkAttributeChange === 'function' && (
            <Dropdown.Item disabled={disabled} onClick={() => onBulkAttributeChange('syndicate', true)}>
              <FontAwesomeIcon className="me-2" fixedWidth icon={faCheckCircle}/>
              Approve for Syndication
            </Dropdown.Item>
          )}
          {onBulkPreview && (
            <Dropdown.Item disabled={disabled} onClick={onBulkPreview}>
              <FontAwesomeIcon className="me-2" fixedWidth icon={faEye}/>
              Preview
            </Dropdown.Item>
          )}
          {typeof onBulkDownload === 'function' && typeof bulkDownloadLink === 'string' && (
            <DownloadButton
              disabled={disabled}
              href={bulkDownloadLink}
              menuIconColor={false}
              menuIconSize="md"
              messageOverride="Download"
              type="MenuItem"
              onClick={onBulkDownload}
            />
          )}
          <Dropdown.Divider />
          <Dropdown.Item disabled={disabled} onClick={onBulkDelete}>
            <FontAwesomeIcon className="me-2" fixedWidth icon={faTrash}/>
            Delete
          </Dropdown.Item>
        </DropdownButton>
      </Col>
    </Row>
  );
}

PhotoBulkActions.propTypes = {
  allSelected: PropTypes.bool.isRequired,
  bulkDownloadLink: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  showLimit: PropTypes.bool.isRequired,
  onBulkAttributeChange: PropTypes.func,
  onBulkDelete: PropTypes.func.isRequired,
  onBulkDownload: PropTypes.func,
  onBulkPreview: PropTypes.func,
  onSelectAll: PropTypes.func.isRequired,
};
